import { useState } from 'react';
import './App.css';

function App() {

  // regular or solid fa-regular fa-heart or fa-solid fa-heart
  
  const [isLiked, setIsLiked] = useState(false);
  const [likeCount, setLikeCount] = useState(99);
  const [likeValue, setLikeValue] = useState('regular');  
  const [likeColor, setLikeColor] = useState('black');


  function handleLike() {
    setIsLiked(!isLiked);
    if (isLiked) {
      setLikeCount(likeCount - 1);
      setLikeValue('regular');
      setLikeColor('black');
    } else {
      setLikeCount(likeCount + 1);
      setLikeValue('solid');
      setLikeColor('red');
    }
  }

  return (
    <div className="container">
      <h1>Photo Like Example</h1>
      <div className="card">
        <h2>Doggy Dog</h2>
        {isLiked ? (<p>You like this post</p>) : (<p>Click to like</p>)}
        <img
          onClick={handleLike}
          src="images/dog.jpg"
          alt="doggy" />
        <div className='like-card'>
            <div>
            {likeCount} Likes
            </div>
            <div>
            <i onClick={handleLike} style={{color : likeColor}} className={`fa-${likeValue} fa-heart`}></i>
            </div>
      </div>  
        
        
      </div>
    </div>
  );
}

export default App;
